export enum ErrorActionTypes {
  ERROR = "@@err/ERROR",
}

export type ErrorActionType = {
  type: ErrorActionTypes.ERROR
  payload: string
}
